import { nestApiClient } from '@wwe-portal/web/services/client/api-client';
import {
  ClaimAllStatusResponse,
  ExclusiveItemResponse,
  MissionItemResponse,
  MissionStatusResponse,
  RecruitRosterRequest,
  RosterItemResponse,
  UpdateRosterResponse,
  UpgradeRosterRequest,
} from '@wwe-portal/entities/club-store.type';

export const getExclusiveItems = () => {
  return nestApiClient.get<{ data: ExclusiveItemResponse[] }>(
    `/club/offers/all`
  );
};

export const getMissionItems = async () => {
  return await nestApiClient.get<{ data: MissionItemResponse[] }>(
    `/club/missions/all`
  );
};

export const getMissionStatuses = () => {
  return nestApiClient.get<{ data: MissionStatusResponse[] }>(
    `/club/missions/all/status`
  );
};

export const getRosterItems = async () => {
  return await nestApiClient.get<{ data: RosterItemResponse[] }>(
    `/club/roster/all`
  );
};

export const getLockedRosters = async () => {
  return await nestApiClient.get<{ data: RosterItemResponse[] }>(
    '/club/roster/all/locked'
  );
};

export const getClaimAllStatus = async () => {
  return await nestApiClient.get<{ data: ClaimAllStatusResponse[] }>(
    `club/missions/all/claim/status`
  );
};

export const updateRoster = async (data: UpgradeRosterRequest) => {
  return await nestApiClient.post<{ data: UpdateRosterResponse }>(
    `/club/roster/upgrade`,
    data
  );
};

export const recruitRoster = async (data: RecruitRosterRequest) => {
  return await nestApiClient.post<{ data: UpdateRosterResponse }>(
    `/club/roster/recruit`,
    data
  );
};

export const claimAllMissions = async () => {
  return await nestApiClient.post(`club/missions/all/claim`);
};
